<template>
  <div class="accordion-item">
    <h2 class="accordion-header" :id="'heading' + props.accordionName + index">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        :data-bs-target="'#collapse' + props.accordionName + index"
        :aria-controls="'collapse' + props.accordionName + index"
      >
        <slot name="question"></slot>
      </button>
    </h2>
    <div
      :id="'collapse' + props.accordionName + index"
      class="accordion-collapse collapse"
      :aria-labelledby="'heading' + props.accordionName + index"
      :data-bs-parent="'#accordion' + props.accordionName"
    >
      <div class="accordion-body">
        <slot name="answer"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  accordionName: string
  index: number
}>()
</script>
